const userReducer = (
    state = {
        loading: false,
        users: []
    },
    action
) => {
    switch (action.type) {
        case 'SET_USERS_REQUEST':
            state = {
                ...state,
                loading: true
            }
            break;
        case 'SET_USERS_SUCCESS':
            console.log('SET_USERS_SUCCESS payload:', action.payload);
            // Handle both nested structure { users: [...] } and direct array
            const usersData = action.payload?.users || action.payload || [];
            state = {
                ...state,
                loading: false,
                users: usersData
            }
            break;
        case 'UPDATE_USER_LIST':
            state = {
                ...state,
                users: (state.users || []).toSpliced(action.payload.index, 1, action.payload.user)
            }
            break;
    }
    return state;
};

export default userReducer;

